import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyle from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        width: '100%',
        margin: theme.spacing(4, 0, 3),
        zIndex: 600,
      },
      search: {
        marginTop: theme.spacing(2),
        width: 300,
      },
      title: {
        flexShrink: 0,
        display: 'block',
        alignItems: 'center',
        fontSize: 18,
        fontWeight: 'bold',
        lineHeight: '28px',
        boxSizing: 'border-box',
        margin: theme.spacing(0, 2),
        width: 'calc(100% - 32px)',
      },
      actions: {
        display: 'flex',
        flex: 'auto',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        margin: theme.spacing(0, 1),
      },
      actionButton: {
        flexShrink: 0,
        backgroundColor: 'white',
        color: sicrediStyle.primarySicrediDark,
        fontSize: 14,
        fontWeight: 'bold',
        '&:not(:last-of-type)': {
          marginRight: theme.spacing(1.5),
        },
      },
      modalContent: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      },
      modalFooter: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: theme.spacing(4),
        '& button:not(:last-of-type)': {
          marginRight: theme.spacing(2),
        },
      },
    }),
  { name: 'MensagensAssessor' }
);
